<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
    <li v-for="item in data" :key="item.title">
      <div class="timeline-icon p-0" :class="`bgg-${item.color}`">
        <!-- <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" /> -->
        <vs-avatar
          v-if="item.userData.profilePictureUrl"
          size="32px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            item.userData.profilePictureUrl
          "
        />
        <vs-avatar
          v-else
          size="32px"
          :src="require('@/assets/images/temp-img/temp-boringavatar.png')"
        />
      </div>
      <div class="timeline-info">
        <div class="flex justify-between">
          <p
            v-if="item.userData && item.userData.firstName"
            class="font-semibold"
          >
            {{ item.userData.firstName }} {{ item.userData.lastName }}
          </p>
          <div v-if="item.userData._id === userData._id">
            <vs-dropdown
              vs-custom-content
              vs-trigger-click
              class="cursor-pointer"
            >
              <a class="a-icon cursor-pointer text-dark" href="#">
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="cursor-pointer"
                  svgClasses="w-5 h-5"
                />
              </a>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  @click.stop="deleteKanbanNote(item._id)"
                  style="min-width: 11rem; font-size: 14.5px"
                >
                  Delete Note
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <span class="activity-desc">{{ item.note }}</span>
      </div>
      <!-- <small class="text-grey activity-e-time">{{ item.time }}</small> -->
    </li>
  </ul>
</template>

<script>
import constants from "@/constants.js";

export default {
  name: "vx-timeline",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      constants,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
  },
  methods: {
    deleteKanbanNote(kanbanNoteId) {
      this.$emit("deleteKanbanNote", kanbanNoteId);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";

.vx-timeline {
  border-left: none !important;
}
</style>
